export type RevisionCheckpoint = {
  id?: number; due_date: string; expected_outcome: string;
  status?: string; verification_status?: string;
};

export const checkpointLocked = (checkpoint: RevisionCheckpoint) =>
  !!checkpoint.id && (checkpoint.status === 'completed' || checkpoint.verification_status === 'verified');

// Revise the schedule without deleting milestone identities or their evidence.
// Reserve matching dates first, then reuse remaining editable records in order.
export function reviseGoalCheckpoints(existing: RevisionCheckpoint[], suggested: RevisionCheckpoint[]) {
  const ordered = [...existing].sort((a, b) => a.due_date.localeCompare(b.due_date));
  const editable = ordered.filter(cp => !checkpointLocked(cp));
  const suggestions = [...suggested].sort((a, b) => a.due_date.localeCompare(b.due_date));
  const used = new Set<RevisionCheckpoint>();
  const matches = suggestions.map(cp => {
    const match = editable.find(old => old.due_date === cp.due_date && !used.has(old));
    if (match) used.add(match);
    return match;
  });
  const revised = suggestions.map((cp, i) => {
    const old = matches[i] || editable.find(candidate => !used.has(candidate));
    if (old) used.add(old);
    return { ...(old || {}), due_date: cp.due_date, expected_outcome: cp.expected_outcome };
  });
  const retained = ordered.filter(cp => !used.has(cp));
  return {
    checkpoints: [...revised, ...retained].sort((a, b) => a.due_date.localeCompare(b.due_date)),
    revisedCount: used.size,
    addedCount: suggestions.length - used.size,
    protectedCount: retained.filter(checkpointLocked).length,
    extraCount: retained.filter(cp => !checkpointLocked(cp)).length,
  };
}
